import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { cardCls } from "@/components/shared";

const Toggle = ({ k, title, text, prefs, onChange }) => (
  <label className="flex items-start justify-between gap-6 py-4 border-b border-t-line last:border-0 cursor-pointer">
    <span>
      <span className="block text-sm font-medium text-t-ink">{title}</span>
      <span className="block text-xs text-t-muted mt-0.5">{text}</span>
    </span>
    <Switch data-testid={`pref-${k}`} checked={!!prefs[k]} onCheckedChange={(v) => onChange(k, v)} />
  </label>
);

export const PrefsSection = ({ title, subtitle, items, testId }) => {
  const { user, setUser } = useAuth();
  const prefs = user.prefs || {};
  const change = async (k, v) => {
    setUser({ ...user, prefs: { ...prefs, [k]: v } });
    try {
      setUser((await api.patch("/auth/preferences", { [k]: v })).data);
      toast.success("Saved");
    } catch (e) {
      setUser(user);
      toast.error(formatApiError(e));
    }
  };
  return (
    <section className={`${cardCls} p-6 sm:p-8`} data-testid={testId}>
      <h2 className="font-serif-display text-2xl font-semibold">{title}</h2>
      <p className="text-sm text-t-muted mt-1 mb-2">{subtitle}</p>
      {items.map((it) => <Toggle key={it.k} {...it} prefs={prefs} onChange={change} />)}
    </section>
  );
};

export const NOTIFICATION_ITEMS = [
  { k: "app_task_reminders", title: "Task reminders", text: "Show a gentle reminder on the overview for tasks due today or overdue." },
  { k: "app_price_drops", title: "Price-drop alerts", text: "Show a \"Prices dropped\" card on the overview when a wishlist item gets cheaper." },
];

export const EMAIL_ITEMS = [
  { k: "email_price_drops", title: "Price-drop emails", text: "Email me when something on my wishlists drops in price." },
  { k: "email_tips", title: "Tips & updates", text: "Occasional emails with ideas for getting more from Base & Balance." },
];
